export default __webpack_public_path__ + "static/media/infrasa-logo.59044bc9.png";